import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isEmpty, isUndefined } from 'lodash'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import CloseCircleIcon from '../../../../assets/icons/CloseCircle.svg?react'
import FilePencilAltIcon from '../../../../assets/icons/FilePencilAlt.svg?react'
import { RightSidebarWrapper } from '../../../../components/Wrapper/RightSidebarWrapper'
import { ContextManagementDialog } from '../../../../dialogs/ContextManagementDialog'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { AgentOrAssistantSelect } from '../../MainPage/components/AgentOrAssistantSelect'
import { SettingForm } from './SettingForm'
import { SettingsAccordion } from './SettingsAccordion'
import { VoiceAnswerSettings } from './VoiceAnswerSettings'
import { getInitSetting } from './getInitSetting'

export const RequestsSetting = () => {
    const params = useParams()
    const [openContextManagementDialog, setOpenContextManagementDialog] = useState<boolean>(false)
    const [expanded, setExpanded] = useState('')
    const { setOpenSidebarType, modelDetail } = useWrapperStore((state) => state)
    const { requestDetail } = useRequestsStore((state) => state)
    const handleClickOpenContextManagementDialog = () => {
        setOpenContextManagementDialog(true)
    }

    const handleContextManagementDialog = () => {
        setOpenContextManagementDialog(false)
    }

    const shouldDisplayVoiceSettings =
        modelDetail?.model_type == 'TEXT' || modelDetail?.model_type == 'AUTO'

    const requestsSettingModel = useMemo(
        () =>
            getInitSetting(modelDetail?.series?.params, requestDetail ? requestDetail?.params : []),
        [modelDetail, requestDetail],
    )

    const requestsSettingParams = useMemo(
        () =>
            getInitSetting(
                modelDetail?.series?.additional_contexts,
                requestDetail ? requestDetail?.additional_contexts : [],
            ),
        [modelDetail, requestDetail],
    )

    return (
        <RightSidebarWrapper>
            <Box sx={{ maxHeight: `calc(100dvh - ${120}px)` }}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', p: 2, alignItems: 'center' }}>
                    <Typography color="text" variant="h5" sx={{ fontWeight: 500 }}>
                        Настройки
                    </Typography>
                    <IconButton
                        sx={{ height: '40px', padding: 0 }}
                        variant="text"
                        onClick={() => setOpenSidebarType(null)}>
                        <CloseCircleIcon />
                    </IconButton>
                </Stack>

                <Divider />
                <Box sx={{ mt: 1, px: '16px' }}>
                    <>
                        <Box
                            sx={{ maxHeight: `calc(100dvh - ${220}px)`, overflow: 'auto', gap: 2 }}>
                            <Button
                                fullWidth
                                sx={{ my: 2 }}
                                variant="contained"
                                color="secondary"
                                startIcon={<FilePencilAltIcon />}
                                onClick={() => {
                                    handleClickOpenContextManagementDialog()
                                }}>
                                Управление контекстом
                            </Button>
                            <Typography
                                component="h5"
                                color="text"
                                sx={{ fontWeight: 500, mt: 3, mb: 1 }}>
                                Модели и ассистенты
                            </Typography>
                            <AgentOrAssistantSelect
                                requestId={params.requestId}
                                isRequestsSetting={true}
                            />

                            {!isUndefined(requestsSettingParams) &&
                                !isEmpty(requestsSettingParams) && (
                                    <SettingsAccordion
                                        divider
                                        value="requestsSettingParams"
                                        expanded={expanded}
                                        title="Параметры запроса"
                                        tooltip="Эти параметры позволяют настроить стиль и формат ответов нейросети, адаптируя их под ваши предпочтения."
                                        onChange={setExpanded}
                                        details={
                                            <SettingForm
                                                initialValues={requestsSettingParams}
                                                data={modelDetail.series.additional_contexts}
                                                nameParams="additional_contexts"
                                            />
                                        }
                                    />
                                )}

                            {!isUndefined(requestsSettingModel) &&
                                !isEmpty(requestsSettingModel) && (
                                    <SettingsAccordion
                                        divider
                                        value="requestsSettingModel"
                                        expanded={expanded}
                                        title="Настройки модели"
                                        tooltip="Эти настройки регулирует поведение, точность, креативность и гибкость ответов, а также их длину и вариативность формулировок."
                                        onChange={setExpanded}
                                        details={
                                            <SettingForm
                                                initialValues={requestsSettingModel}
                                                data={modelDetail.series.params}
                                                nameParams="params"
                                            />
                                        }
                                    />
                                )}
                            {shouldDisplayVoiceSettings && (
                                <SettingsAccordion
                                    value="voiceSettings"
                                    expanded={expanded}
                                    title="Голосовой режим"
                                    tooltip="Режим позволяет получать ответы в виде голосовых сообщений от нейросети"
                                    onChange={setExpanded}
                                    details={<VoiceAnswerSettings />}
                                />
                            )}
                        </Box>
                    </>
                </Box>
            </Box>
            <ContextManagementDialog
                type="request"
                open={openContextManagementDialog}
                handleClose={handleContextManagementDialog}
            />
        </RightSidebarWrapper>
    )
}
